import Clone from './Clone'
import ConvertToSubcontract from './ConvertToSubcontract'
import CreateSubcontract from './CreateSubcontract'
import Edit from './Edit'
import Export from './Export'
import Renew from './Renew'
import Terminate from './Terminate'
import Scanner from './Scanner'
import SubcontractAddMenu from './SubcontractAddMenu'

const ContractButtons = {
    Edit,
    Clone,
    // ConvertToSubcontract and CreateSubcontract are still exported on their own: the partner
    // contract page uses CreateSubcontract directly, and convert has no meaning there.
    ConvertToSubcontract,
    CreateSubcontract,
    SubcontractAddMenu,
    Export,
    Renew,
    Terminate,
    Scanner,
}
export default ContractButtons
